import classNames from 'classnames';
import styles from './BasketTile.module.scss';

export interface BasketTileProps {
	className?: string;
	element?: 'li' | 'article' | 'section'; // use 'li' when rendered inside list, 'article' for standalone cards, 'section' for thematic groupings
	onClick?: () => void;
	ariaLabel?: string;
	bgColor?: string;
	children?: React.ReactNode;
}

export const BasketTile: React.FC<BasketTileProps> = ({
	className,
	element: WrapperElement = 'article',
	onClick,
	ariaLabel,
	bgColor,
	children,
}) => {
	const wrapperClass = classNames(styles.BasketTile, bgColor && styles.BasketTile__customBg, className);
	const style = bgColor ? { background: bgColor } : undefined;

	if (onClick) {
		// Inner <button> owns interaction; avoids role="button" overriding the wrapper's implicit role (e.g. listitem on <li>).
		return (
			<WrapperElement
				className={wrapperClass}
				style={style}
			>
				<button
					type='button'
					className={styles.BasketTile__clickable}
					aria-label={ariaLabel}
					onClick={onClick}
				>
					{children}
				</button>
			</WrapperElement>
		);
	}

	return (
		<WrapperElement
			className={wrapperClass}
			style={style}
		>
			{children}
		</WrapperElement>
	);
};
